var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 40,
    viewBox: "0 0 201 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.2224 32.17H58.4671V21.9761H66.0941V16.7499H58.4671V11.8007H66.0941V6.57446H53.2224V32.17Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.495 6.57446V32.1885H73.7213V21.9761H78.6705V32.17H83.8967V21.8284H81.3482V19.4276H83.8967V9.10447V6.57446H81.3482H68.495ZM78.6705 16.7499H73.7213V11.8007H78.6705V16.7499Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3159 32.17H99.1691V26.9253H91.5421V21.9761H99.1691V16.7499H91.5421V11.8007H99.1691V6.57446H86.3159V32.17Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.57 32.17H114.441V26.9253H106.796V21.9761H114.441V16.7499H106.796V11.8007H114.441V6.57446H101.57V32.17Z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.695 6.57446H116.824V32.1885H129.695V29.6216H132.244V9.12294H129.695V6.57446ZM127.018 26.9253H122.068V11.8007H127.018V26.9253Z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.193 6.57446V6.64833H134.792V9.10447H134.645V29.6031V32.17H137.193H147.516V32.0962H150.065V29.6216V9.12294V6.57446H147.516H137.193ZM144.82 26.9253H139.871V11.8007H144.82V26.9253Z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.466 6.57446V32.17H157.692V11.8007H162.641V32.17H167.867V11.8007H172.816V32.17H178.043V6.57446H152.466Z",
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.669 32.17H180.443V6.57446H193.315V11.8007H185.669V16.7499H193.315V21.9761H185.669V32.17Z",
    fill: "#EACF1A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M200.942 6.57446H195.716V32.1885H200.942V6.57446Z",
    fill: "#EACF1A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40H45.4109V0H0V40ZM22.6408 18.0979H27.1837V22.5669H22.6408H18.1163V18.0979H22.6408ZM9.03047 9.03047H13.5734H18.1163V13.4995H13.5734H9.03047V9.03047ZM9.47368 22.2715H13.9427V26.7405H9.47368V22.2715ZM31.6343 31.1911H27.1837H22.6593H18.2641H18.1163H13.795V26.7221H18.1163H18.2641H22.6593H27.1837H31.6343V31.1911ZM35.8079 26.7405H31.3389V22.2715H35.8079V26.7405ZM36.4174 13.4995H31.8744H27.3315V9.03047H31.8744H36.4174V13.4995Z",
    fill: "#EACF1A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1164 13.4996V9.03052H13.5734H9.03049V13.4996H13.5734H18.1164Z",
    fill: "#0A1522"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1164 22.5671H22.6409H27.1838V18.098H22.6409H18.1164V22.5671Z",
    fill: "#0A1522"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9428 22.2716H9.47372V26.7407H13.9428V22.2716Z",
    fill: "#0A1522"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8264 22.2716H31.3573V26.7407H35.8264V22.2716Z",
    fill: "#0A1522"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1837 26.7406H22.6408H18.264H18.1163H13.795V31.1912H18.1163H18.264H22.6408H27.1837H31.6343V26.7406H27.1837Z",
    fill: "#0A1522"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8744 9.03052H27.3315V13.4996H31.8744H36.4173V9.03052H31.8744Z",
    fill: "#0A1522"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.62b38093cf3a05a889bf6fc6979e4f43.svg";
export { ForwardRef as ReactComponent };